import { Box, Typography, useTheme } from '@mui/material';
import { getSeriesLabel } from './chart-tooltip-utils';
import { TooltipData } from './types';

type ChartTooltipSingleProps = {
  data: TooltipData;
};

/**
 * Compact tooltip shown when the cursor is near a single chart line.
 */
export function ChartTooltipSingle({ data }: ChartTooltipSingleProps) {
  const theme = useTheme();
  const item = data.series[0];
  const label = getSeriesLabel(item.label);
  const color = typeof item.color === 'string' ? item.color : theme.palette.text.primary;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: color,
            borderRadius: '50%',
            flexShrink: 0,
          }}
        />
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {label}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ color: 'grey.300' }}>
        {data.timestamp}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {item.value.toLocaleString()}
      </Typography>
    </Box>
  );
}
